import apiClient from "./api";

export const getRfi = async () => {
    try {
      const response = await apiClient.get('/api/Rfi');
      return response.data;
    } catch (error) {
      // console.error("Error fetching accounts:", error);
      throw error("Error fetching accounts:", error);
    }
};

export const getRfiCompleted = async (domainId) =>{
    try{
      const response = await apiClient.get(`/api/Rfi/RfiStatusCompleted`);
      return response.data;
    }catch(error){
      //  console.error('Erreur lors de la récupération des Rfis :', error);
       throw error('Erreur lors de la récupération des Rfis :', error)
    }
};

// recuperer tous les rfis d'un domain specifique
export const getAllRfi = async (page, size) => {
  try {
      const response = await apiClient.get(`api/Rfi/GetAll?page=${page}&size=${size}`);
      if (response.status !== 200) {
          throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.data;
  } catch (error) {
      // console.error('Error fetching all RFIs:', error);
      throw error('Error fetching all RFIs:', error);
  }
};

// gerer par status les rfi
export const getRfiByStatus = async (status, domainId) => {
  try {
    const response = await apiClient.get(`/api/Rfi/RfiStatus/${status}/${domainId}`);
    return response.data;
  } catch (error) {
    // console.error("Erreur lors de la récupération des RFI par statut :", error);
    throw error("Erreur lors de la récupération des RFI par statut :", error); // Propager l'erreur pour la gérer dans le composant appelant
  }
};

// supprimer une rfi 
export const deleteRfi = async (id) => {
  try {
      await apiClient.delete(`/api/Rfi/${id}`);
  } catch (error) {
      console.error('Erreur lors de la suppression du RFI :', error);
      throw error('Erreur lors de la suppression du RFI :', error);
  }
};

// gerer l'affichage des rfis par createur
export const getRfiByCreatorId = async (creatorId, domainId) => {
  try {
      const response = await apiClient.get(`api/Rfi/${creatorId}/${domainId}`);
      return response.data;
  } catch (error) {
      // console.error('Error fetching RFIs by creator ID:', error);
      throw error('Error fetching RFIs by creator ID:', error);
  }
};

// autres filtres par date
export const getRfiByDate = async (domainId) => {
  try {
      const response = await apiClient.get(`/api/Rfi/GetRfiByMonth/${domainId}`);
      return response.data;
  } catch (error) {
      // console.error('Error fetching RFIs by date:', error);
      throw error('Error fetching RFIs by date:', error);
  }
};

// recuperer les rfis par mois
export const getRfiByMonth = async (domainId) => {
  try {
      const response = await apiClient.get(`/api/Rfi/GetRfiByMonth/${domainId}`);
      return response.data;
  } catch (error) {
      // console.error('Error fetching RFIs by month:', error);
      throw error('Error fetching RFIs by month:', error);
  }
};
// recuperer les rfi par annee
export const getRfiByYear = async (domainId) => {
  try {
      const response = await apiClient.get(`/api/Rfi/GetRfiByYear/${domainId}`);
      return response.data;
  } catch (error) {
      // console.error('Error fetching RFIs by year:', error);
      throw error('Error fetching RFIs by year:', error);
  }
};

// creer une rfi
export const rfiCreate = async (rfiData) => {
  try {
      const response = await apiClient.post(`/api/Rfi`, rfiData);
      return response.data;
  } catch (error) {
      // console.error("Error creating RFI:", error.response?.data || error.message);
      throw error("Error creating RFI:", error.response?.data || error.message);
  }
};

/**
 * Met à jour une RFI
 * @param {number} id – l'ID de la RFI à mettre à jour
 * @param {object} payload – un UpdateRfiCommand (doit contenir au moins .id, .securityName, .price, .quantity, etc.)
 */
export const updateRfi = async (id, payload) => {
  try {
    const response = await apiClient.put(`/api/Rfi/${id}`, payload);
    // console.log('Réponse de l\'API PUT :', response.data);
    return response.data;
  } catch (error) {
    // console.error("Erreur lors de la mise à jour de la RFI :", error.response?.data || error.message);
    throw error("Erreur lors de la mise à jour de la RFI :", error.response?.data || error.message);
  }
};

